var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"roll-user-bets"},_vm._l((_vm.rollGetUserBets),function(bet){return _c('RollUserBetsElement',{key:bet._id,attrs:{"bet":bet}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }